export default __webpack_public_path__ + "static/media/star-bg-small.8a43543b.svg";